mutation UpdateSmsDripSequence($input: SmsDripSequenceUpdateInput!) {
    smsDripSequenceUpdate(input: $input) {
        campaign {
            id
            name
            htmlUrl
            htmlUrlPath
            isStopOnGoal
        }
    }
}
